import { styles } from '../../../../utilities'
import type { Tokens } from '../../../../theming/types'

export default (config: {
  props: { overCharacterLimit?: boolean }
  tokens: Tokens
}) => {
  const { props, tokens } = config

  return {
    default: {
      wrap: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        minHeight: '20px',
        whiteSpace: 'pre-wrap',
        width: '100%',
      },
      text: {
        color: props.overCharacterLimit
          ? tokens.fontColorError
          : tokens.fontColorSubtle,
      },
      count: {
        paddingInlineStart: tokens.spacingGap200,
      },
    },
    hidden: styles.visuallyHidden,
  } as const
}
